import React, { Component } from 'react';

import firebase from '../Config/Firebase';          //Firebase config     
import Header from './Header';                      //Header Component       
import WaitContainer from './WaitContainer';        //Wait Container Component
import SplitModeButtons from './SplitModeButtons';         //Split Equal Buttons Component   
import DisplayItemList from './ItemList';           //Display Item List and Item Details component
import SplitEqualComponent from './SplitEqualComponent';                  //Split Equal Component (shows the data when Split Equal Chosen)
import PaymentReceipt from './PaymentReceipt';        //Payment Status page on completion of payment for all items
import Footer from './Footer';                      //Footer Component shows the sum total with Pay Button
import jdenticon from 'jdenticon';                  //Jdenticon 

import '../Assets/css/App.css';                     //App related css

class App extends Component {
  constructor(props) {
    super(props);
    //Fetch TableID
    let tableID = this.getTableID(window.location.href);

    //Initial State
    this.state = {
      name: '',
      logoRef: '',
      tableID: tableID,
      splitType: '',
      loggedInUser: '',
      owner: '',
      items: [],
      users: [],
      loading: true,
      isDataLoaded: false,
      tableTotal: '',
      userBillPaid: false,
      totalUsers: '',
      error: false,
      paybyItemsCompleted: false
    }

  }

  //Get Table ID from URL
  getTableID(url) {
    return url.split('?tableID=')[1];
  }

  //Get User 
  getUser() {
    let resolved = false;
    return new Promise((res, rej) => {
      // Get user auth
      firebase.auth().onAuthStateChanged((user) => {
        if (resolved) {
          return;
        }
        resolved = true;
        if (!user) {
          // Ifn user doesn't exist, create them and then return that user
          return firebase.auth().signInAnonymously().then((userCredential) => {
            res(userCredential.user);
          });
        } else {
          res(user);
        }
      });
    });
  }

  //Verify if user is created else create a new user
  verifyUserTable() {
    let uid = this.state.loggedInUser; // Only set if user is loaded
    let tableId = this.state.tableID;
    let users = this.state.users;
    let ownerId = this.state.owner;
    if (!uid // If user not loaded
      || !this.state.isDataLoaded // or date not loaded
      || !this.state.loading) { // Or loading has completely finished
      return Promise.resolve();
    }

    let promises = [];
    // Is the user on the table?
    if (!users[uid]) {
      promises.push(firebase.database().ref(`/tables/${tableId}/users/${uid}`).set({ userBillPaid: false }));
    }

    // Does the table have an owner?
    if (!ownerId) {
      promises.push(firebase.database().ref(`/tables/${tableId}/owner`).set(uid));
    }
    // if(users[uid].userBillPaid){
    //   this.setState({userBillPaid: true});
    // }
    return Promise.all(promises).then(() => {
      this.setState({ loading: false });
    });
  }

  isTablePaidCompletely(items, users, amountPaid, tableTotal) { //to check if all the items on the table are paid completely.
    if (amountPaid === tableTotal) {
      return true;
    } else {
      return false;
    }
  }

  componentWillMount() {
    if (this.state.tableID) {
      // This logic fires onces
      this.getUser().then((user) => {
        this.setState({ loggedInUser: user.uid });
        // Check that user is on table
        this.verifyUserTable();
      }).catch((error) => {
        // set error state
        this.setState({
          error: true //Unable to get user details. Something went wrong with the user.
        })
      });

      //Get Firebase data for a table
      const tablesRef = firebase.database().ref(`tables/${this.state.tableID}`);
      tablesRef.on('value', snapshot => {
        // This logic runs every time firebase data changes
        let data = snapshot.val();
        if (data) {
          let logoRef = snapshot.key;
          //Set the state once data is retrieved or updated.

          this.setState({
            name: data.name,
            logoRef: logoRef,
            items: data.items ? data.items : [], // if there are no items, then assign an empty array.
            users: data.users ? data.users : [], // if there are no users, then assign an empty array.
            paymentStatus: data.paymentStatus,
            owner: data.owner,
            splitType: data.splitType,
            restaurantName: data.restaurantName,
            restaurantImage: data.restaurantImage,
            tableTotal: (data.tableTotal / 100).toFixed(2),
            isDataLoaded: true,
            splitByTotalUsers: data.splitByTotalUsers,
            splitBillTotal: data.splitBillTotal,
            splitBillCompleted: data.splitBillCompleted,
            paybyItemsCompleted: data.paybyItemsCompleted,
            amountPaid: data.amountPaid,
            currentDate: (new Date()).toDateString()
          });

          //check for each items if their bills are paid
          //If all bills are paid , then set userBillPaid to true.
          for (var i in data.users) {
            if (i === this.state.loggedInUser) {
              if (!data.splitType) {
                return;
              }
              if (data.splitType === "paybyitems") {
                let isTablePaidCompletely = this.isTablePaidCompletely(data.items, data.users, data.amountPaid, data.tableTotal);
                this.setState({
                  paybyItemsCompleted: isTablePaidCompletely
                })
              }
              if (data.splitType === "splitequally") {
                if (data.users[i].userBillPaid) {
                  this.setState({
                    userBillPaid: true
                  });
                }
              }
            }
          }

          // Check that user is on table
          this.verifyUserTable().catch((error) => {
            this.setState({
              error: true, //No Data available
              errorMessage: error
            });
          });
        } else {
          this.setState({
            error: true //Wrong tableID
          });
        }
      });
    } else {
      console.error("Unable to retrieve the Table ID.");
      this.setState({
        error: true, //No Table ID 
        errorMessage: 'Unable to retrieve the TableID'
      });
    }
  }

  componentDidUpdate() {
    jdenticon.update('.jdenticon');
  }

  render() {
    return (
      <div className="wrapper">
        <Header //Show the Header with the table Name, Restaurant Name, LoggedinUser via the jdenticon
          tableID={this.state.tableID}
          tableName={this.state.name}
          restaurantName={this.state.restaurantName}
          restaurantImage={this.state.restaurantImage}
          loggedInUser={this.state.loggedInUser}
          tableTotal={this.state.tableTotal}
          error={this.state.error}
        />
        { //Show the Split Buttons to the owner and only if the data loaded is true on
          (this.state.isDataLoaded &&                                   // If the data is loaded (true)
            (this.state.splitType === "") &&                            // If the SplitType is not set
            (this.state.owner === this.state.loggedInUser)              // If the loggedInUser is owner
          ) &&
          <SplitModeButtons
            splitType={this.state.splitType}
            owner={this.state.owner}
            loggedInUser={this.state.loggedInUser}
            tableID={this.state.tableID}
          />
        }
        { //Display the Wait Container 
          (this.state.isDataLoaded &&                                   // If the data is Loaded
            (                                                           // If the split Type is splitequally (Split Equally)
              (this.state.splitType === "splitequally") ||
              (this.state.splitType === "")
            ) &&
            (this.state.owner !== this.state.loggedInUser) &&           // If the user is not owner
            !this.state.splitByTotalUsers &&                            // If SplitEqual, check if the Split By Users is set
            (this.state.paymentStatus !== 'paid'                        // If the paymentStatus is not Paid
            )) &&
          <WaitContainer />
        }

        { //Display Items 




          // If the userBillPaid (total bill) is not paid (false)
          (this.state.isDataLoaded &&                                   // If the data is loaded 
            (this.state.splitType === 'paybyitems') &&                  // If the splitType is pay per items on 
            (this.state.paymentStatus !== 'paid') &&                    // If the paymentstatus is unpaid (not paid)
            !this.state.userBillPaid &&                                 // If the userBillPaid flag is false (not required)
            !this.state.paybyItemsCompleted                             // If all the items are paid
          ) &&
          <div className="listContainer">
            <div className="item-group">
              <DisplayItemList
                loggedInUser={this.state.loggedInUser}
                items={this.state.items}
                tableID={this.state.tableID}
              />
            </div>
          </div>
        }
        { //Display SplitEqualComponent
          (
            this.state.isDataLoaded &&                                  //If the data is loaded    
            (this.state.splitType === 'splitequally') &&                //If the mode is Split Equal Mode
            (this.state.paymentStatus !== 'paid') &&                    //If the paymentStatus is unpaid (not paid)
            // (this.state.owner === this.state.loggedInUser) &&           //If the user is an Owner
            !this.state.userBillPaid                                    //If user bill paid    
          ) &&
          <div className="container">
            <SplitEqualComponent //ComputeBillTotal
              items={this.state.items}
              loggedInUser={this.state.loggedInUser}
              owner={this.state.owner}
              users={this.state.users}
              tableID={this.state.tableID}
              type={this.state.splitType}
              tableTotal={this.state.tableTotal}
              splitByTotalUsers={this.state.splitByTotalUsers}
              splitBillTotal={this.state.splitBillTotal}
              splitBillCompleted={this.state.splitBillCompleted}
            />
          </div>
        }


        { //Display the Payment completion page for all the users on
          // If the userBillPaid is true
          //TODO : Optimisation required here
          //Show the PaymentStatus Button
          (
            this.state.paybyItemsCompleted ||
            this.state.userBillPaid                                    //specifically for SplitEqualMode
          ) &&
          <PaymentReceipt
            amountPaid={this.state.amountPaid}
            tableTotal={this.state.tableTotal}
            type={this.state.splitType}
            owner={this.state.owner}
            loggedInUser={this.state.loggedInUser}
            splitBillTotal={this.state.splitBillTotal}
            splitByTotalUsers={this.state.splitByTotalUsers}
            paymentStatus={this.state.paymentStatus}
            users={this.state.users}
            items={this.state.items}
            currentDate={this.state.currentDate}
          />
        }

        { /* 
            Footer component responsible for showing 
            the selected item total or split equal total 
        */}
        <Footer
          type={this.state.splitType}
          items={this.state.items}
          owner={this.state.owner}
          loggedInUser={this.state.loggedInUser}
          users={this.state.users}
          tableID={this.state.tableID}
          splitBillTotal={this.state.splitBillTotal}
          splitBillUsers={this.state.splitByTotalUsers}
          splitBillCompleted={this.state.splitBillCompleted}
          tableTotal={this.state.tableTotal}
          amountPaid={this.state.amountPaid}
        />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App.js